export default "__VITE_ASSET__CZ0QpOq3__"